module.exports = {
	env: {
		API: "https://adminportalsosyalag.anadoluhayat.com.tr",
		PORT: 8012,
		LOGINTYPE: "emailPass",
		ISPOSTGROUP: 0
	}
} 